import React from 'react';
import { number, element, oneOfType, arrayOf } from 'prop-types';
import Helmet from 'react-helmet';
import { Route } from 'react-router-dom';
import { Header } from 'semantic-ui-react';


const Status = ({ code, children }) => (
    <Route render={({ staticContext }) => {
        // NOTE: staticContext will be available only on the server
        if (staticContext) {
            staticContext.status = code; // eslint-disable-line no-param-reassign
        }
        return children;
    }}
    />
);

Status.propTypes = {
    code: number.isRequired,
    children: oneOfType([
        element,
        arrayOf(element),
    ]).isRequired,
};


export const NotFound = () => (
    <Status code={404}>
        <Helmet title="Not Found" />

        <Header as="h1" textAlign="center">Sorry, page not found.</Header>
    </Status>
);

export default NotFound;
